import React, { useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import { Form } from 'antd';
import Widget from '../../Helpers/Widget';
const get_access_settings = JSON.parse(localStorage.getItem("access_settings") || "{}");
const role = localStorage.getItem("rxdx_role");
const check_dynamic_access = (module_name, access, role) => {
  if (role === 'admin') return true;
  if (access === 'staff') return false;
  const moduleAccess = get_access_settings[module_name];
  return Array.isArray(moduleAccess) && moduleAccess.includes(access);
};
const AccessSettingsProvider = (props) => {
  const api = new API();
  const [accessList, setAccessList] = useState([]);
  const [accessListTableFilter, setAccessListTableFilter] = useState({
    name: '',
    _id: null,
    page: 1,
    limit: 20
  });
  const [accessListLoader, setAccessListLoader] = useState(false);
  const [accessCategoryList, setAccessCategoryList] = useState([]);
  const [accessCategoryLoader, setAccessCategoryLoader] = useState(false);
  const [accessSubCategoryList, setAccessSubCategoryList] = useState([]);
  const [accessSubCategoryLoader, setAccessSubCategoryLoader] = useState(false);
  const [formAddAccessSettings] = Form.useForm();
  const [formEditAccessSettings] = Form.useForm();
  const [addAccessFromLoader, setAddAccessFromLoader] = useState(false);
  const [addAccessSingleLoader, setAddAccessSingleLoader] = useState(false);
  const [addAccessSingleData, setAddAccessSingleData] = useState({});
  const [updateAccessFromLoader, setUpdateAccessFromLoader] = useState(false);
  const [deleteAccessFromLoader, setDeleteAccessFromLoader] = useState(false);
  const fetchAccessSettings = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setAccessListLoader(true);
    (await api.getAll("accesssettings", { ...accessListTableFilter }, (err, res) => {
      if (res) {
        setAccessList(res?.data?.data);
        setAccessListLoader(false);
      } else {
        setAccessList([]);
        setAccessListLoader(false);
      }
    }));
  };

  const fetchAccessSettingsSingle = async (id) => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
    setAddAccessSingleLoader(true);
    (await api.getSingle("accesssettings/single", id, (err, res) => {
      if (res) {
        setAddAccessSingleData(res?.data?.data);
        if(res?.data?.data) {
          fetchAccessSubCategory(res?.data?.data?.category);
          formEditAccessSettings.setFieldsValue(res?.data?.data);
        }
        setAddAccessSingleLoader(false);
      } else {
        setAddAccessSingleData({});
        setAddAccessSingleLoader(false);
      }
    }));
  };

  const fetchAccessCategory = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setAccessCategoryLoader(true);
    (await api.getAll("accesssettings/categorydropdown", {}, (err, res) => {
      if (res?.data?.status === 200) {
        setAccessCategoryList(res?.data?.data);
        setAccessCategoryLoader(false);
      } else {
        setAccessCategoryList([]);
        setAccessCategoryLoader(false);
      }
    }));
  };
//subcategorydropdown
const fetchAccessSubCategory = async (id) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
    setAccessSubCategoryLoader(true);
  (await api.getAll("accesssettings/subcategorydropdown", {
    category_id:id
  }, (err, res) => {
    if (res?.data?.status === 200) {
      setAccessSubCategoryList(res?.data?.data);
      setAccessSubCategoryLoader(false);
    } else {
      setAccessSubCategoryList([]);
      setAccessSubCategoryLoader(false);
    }
  }));
};

const addAccessSettingsFormFetch = async (data,navi) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
    setAddAccessFromLoader(true);
  (await api.create("accesssettings", {
    ...data,
    status: data.status ? 1 : 0
  }, (err, res) => {
    
    if (res) {
      formAddAccessSettings.resetFields();
      setAddAccessFromLoader(false);
      navi && navi("/access_settings");
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setAddAccessFromLoader(false);
    }
  }));
};

const updateAccessSettingsFormFetch = async (data,navi) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
    setUpdateAccessFromLoader(true);
  (await api.update("accesssettings/edit",addAccessSingleData?._id, {
    ...data,
    status: data.status ? 1 : 0
  }, (err, res) => {
    
    if (res) {
      setUpdateAccessFromLoader(false);
      navi && navi("/access_settings");
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setUpdateAccessFromLoader(false);
    }
  }));
};

const deleteAccessSettings = async (id) => {
  localStorage.getItem("rxdx_admin_login") === "true" &&
  setDeleteAccessFromLoader(true);
  (await api.remove("accesssettings/delete", id, (err, res) => {
    if (res) {
      fetchAccessSettings();
      setDeleteAccessFromLoader(false);
    } else {
      Widget.showMessage("error", err?.response?.data?.message||"Something went wrong");
      setDeleteAccessFromLoader(false);
    }
  }));
};


  return (
    <Context.Provider value={{
      ...props,
      accessList, setAccessList,
      accessListTableFilter, setAccessListTableFilter,
      accessListLoader, setAccessListLoader,
      fetchAccessSettings,
      formAddAccessSettings,
      accessCategoryList, setAccessCategoryList,
      accessCategoryLoader, setAccessCategoryLoader,
      accessSubCategoryList, setAccessSubCategoryList,
      accessSubCategoryLoader, setAccessSubCategoryLoader,
      fetchAccessCategory,
      fetchAccessSubCategory,
      addAccessSettingsFormFetch,
      addAccessFromLoader, setAddAccessFromLoader,
      fetchAccessSettingsSingle,
      addAccessSingleLoader, setAddAccessSingleLoader,
      addAccessSingleData, setAddAccessSingleData,
      formEditAccessSettings,
      updateAccessFromLoader, setUpdateAccessFromLoader,
      updateAccessSettingsFormFetch,
      updateAccessFromLoader, setUpdateAccessFromLoader,
      deleteAccessFromLoader, setDeleteAccessFromLoader,
      deleteAccessSettings,
      get_access_settings,
      role,
      check_dynamic_access
    }}>
      {props.children}
    </Context.Provider>
  )
};

export default AccessSettingsProvider;
